import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-cream-light bg-forest border-2 border-gold rounded-full shadow-[0_8px_24px_rgba(20,67,42,0.25)] hover:bg-forest-light hover:shadow-[0_10px_30px_rgba(201,162,39,0.35)] transition-all duration-300';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-55" data-mp="23bmeeobqks6g">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} {...props} data-id="element-56" data-mp="d28mlaywry11">
      {children}
    </motion.button>;
}